// /* global BigInt */
// import React, { useState, useRef, useEffect } from "react";

// export default function Memory({
//   memory,
//   setMemory,
//   memView,
//   setMemView,
//   memPage,
//   setMemPage,
//   highlightedAddrs,
//   SEGMENTS,
//   addLog,
//   registers
// }) {
//   const PAGE_SIZE = 128;
//   const HALF_PAGE = PAGE_SIZE / 2; // 64

//   const totalPages = Math.ceil(
//     Math.max(SEGMENTS.text.size, SEGMENTS.data.size) / HALF_PAGE
//   );

//   const [editingMem, setEditingMem] = useState(null);
//   const [tempMemValue, setTempMemValue] = useState("");

//   // 🔍 SEARCH STATE (HEX ONLY)
//   const [searchHex, setSearchHex] = useState("");
//   const [searchedAddr, setSearchedAddr] = useState(null);

//   const rowRefs = useRef(new Map());

//   // ---------------- HELPERS ----------------
//   const parseInput = (input, view) => {
//     if (!input) return NaN;
//     switch (view) {
//       case "hex": return parseInt(input, 16);
//       case "dec": return parseInt(input, 10);
//       case "bin": return parseInt(input, 2);
//       default: return NaN;
//     }
//   };

//   const saveMemory = (globalIndex) => {
//     const num = parseInput(tempMemValue, memView);
//     if (isNaN(num)) {
//       addLog(`Invalid input for Memory[0x${globalIndex.toString(16).padStart(3, "0")}]`);
//       setEditingMem(null);
//       return;
//     }
//     if (num < 0 || num > 0xff) {
//       addLog(`Error: Cannot store value in Memory[0x${globalIndex.toString(16).padStart(3, "0")}], max 8 bits allowed`);
//       setEditingMem(null);
//       return;
//     }

//     const updated = [...memory];
//     updated[globalIndex] = num.toString(16).padStart(2, "0").toUpperCase();
//     setMemory(updated);
//     setEditingMem(null);

//     addLog(`Memory[0x${globalIndex.toString(16).padStart(3, "0")}] updated to ${num} (${memView.toUpperCase()})`);
//   };

//   const getColumnMemory = (segmentName) => {
//     const { start, size } = SEGMENTS[segmentName];
//     const colMem = [];
//     for (let i = 0; i < HALF_PAGE; i++) {
//       const addr = start + i + memPage * HALF_PAGE;
//       if (addr < start + size && addr < memory.length) colMem.push(memory[addr]);
//       else colMem.push("00");
//     }
//     return colMem;
//   };

//   const getSegmentColor = (addr) => {
//     for (let seg in SEGMENTS) {
//       const { start, size, color } = SEGMENTS[seg];
//       if (addr >= start && addr < start + size) return color;
//     }
//     return "#888";
//   };

//   const renderPageNumbers = () => {
//     const pageButtons = [];
//     const maxButtons = 5;

//     let start = Math.max(0, memPage - Math.floor(maxButtons / 2));
//     let end = Math.min(totalPages, start + maxButtons);
//     if (end - start < maxButtons) start = Math.max(0, end - maxButtons);

//     for (let i = start; i < end; i++) {
//       pageButtons.push(
//         <button
//           key={i}
//           onClick={() => setMemPage(i)}
//           style={{
//             padding: "2px 6px",
//             borderRadius: "4px",
//             border: "1px solid #888",
//             background: i === memPage ? "#0f0" : "#222",
//             color: i === memPage ? "#000" : "#fff",
//             cursor: "pointer",
//             fontFamily: "monospace",
//             fontWeight: i === memPage ? "bold" : "normal"
//           }}
//         >
//           {i + 1}
//         </button>
//       );
//     }
//     return pageButtons;
//   };

//   const formatValue = (val, view) => {
//     const num = parseInt(val, 16) >>> 0;
//     switch (view) {
//       case "dec": return num.toString();
//       case "bin": return "0b" + num.toString(2).padStart(8, "0");
//       default: return "0x" + val.toUpperCase();
//     }
//   };

//   const leftColMemory = getColumnMemory("text");
//   const rightColMemory = getColumnMemory("data");

//   // ✅ IMPORTANT: your UI shows left 0x000..0x7FF and right 0x800..0xFFF
//   const LEFT_BASE = SEGMENTS.text.start; // 0x000
//   const RIGHT_BASE = SEGMENTS.data.start; // 0x800 (2048)

//   // ---------------- HEX SEARCH LOGIC (FIXED FOR YOUR 2-COLUMN LAYOUT) ----------------
//   const jumpToAddress = () => {
//     if (!searchHex) return;

//     const addr = parseInt(searchHex, 16);
//     if (isNaN(addr) || addr < 0 || addr >= memory.length) {
//       addLog("Invalid memory address");
//       return;
//     }

//     // ✅ page depends on which COLUMN range the address belongs to
//     // left column: 0x000..0x7FF  => page = addr / 64
//     // right column:0x800..0xFFF  => page = (addr-0x800) / 64
//     const page =
//       addr < RIGHT_BASE
//         ? Math.floor((addr - LEFT_BASE) / HALF_PAGE)
//         : Math.floor((addr - RIGHT_BASE) / HALF_PAGE);

//     setSearchedAddr(addr);
//     setMemPage(Math.max(0, Math.min(page, totalPages - 1)));

//     addLog(`🔍 Jumped to memory address: 0x${addr.toString(16).toUpperCase()}`);
//   };

//   // 🔥 Smooth scroll after page change
//   useEffect(() => {
//     if (searchedAddr == null) return;
//     const el = rowRefs.current.get(searchedAddr);
//     if (el) {
//       el.scrollIntoView({ behavior: "smooth", block: "center" });
//     }
//   }, [memPage, searchedAddr]);

//   // ---------------- GO TO SP (ALSO FIXED TO MATCH YOUR 2-COLUMN LAYOUT) ----------------
//   const goToSP = () => {
//     if (!registers || !registers[2]) {
//       addLog("SP (x2) not available");
//       return;
//     }

//     const spAddr = parseInt(registers[2], 16);
//     if (isNaN(spAddr) || spAddr < 0 || spAddr >= memory.length) {
//       addLog("Invalid SP value");
//       return;
//     }

//     const page =
//       spAddr < RIGHT_BASE
//         ? Math.floor((spAddr - LEFT_BASE) / HALF_PAGE)
//         : Math.floor((spAddr - RIGHT_BASE) / HALF_PAGE);

//     setSearchedAddr(spAddr);
//     setMemPage(Math.max(0, Math.min(page, totalPages - 1)));

//     addLog(`Jumped to SP (x2): 0x${spAddr.toString(16).toUpperCase()}`);
//   };

//   const buttonStyle = (active) => ({
//     marginRight: "5px",
//     padding: "2px 6px",
//     border: "1px solid #888",
//     borderRadius: "4px",
//     background: active ? "#0f0" : "#222",
//     color: active ? "#000" : "#fff",
//     cursor: "pointer",
//     fontWeight: active ? "bold" : "normal",
//     fontFamily: "monospace"
//   });

//   const navBtn = {
//     padding: "2px 6px",
//     borderRadius: "4px",
//     border: "1px solid #888",
//     background: "#222",
//     color: "#fff",
//     cursor: "pointer",
//     fontFamily: "monospace"
//   };

//   return (
//     <div
//       style={{
//         flex: 0.9,
//         border: "2px solid #333",
//         borderRadius: "6px",
//         margin: "5px",
//         background: "#1b1b1b",
//         display: "flex",
//         flexDirection: "column",
//         minHeight: 0
//       }}
//     >
//       {/* ---------------- STICKY HEADER ---------------- */}
//       <div
//         style={{
//           position: "sticky",
//           top: 0,
//           zIndex: 5,
//           background: "#1b1b1b",
//           padding: "10px",
//           borderBottom: "1px solid #555"
//         }}
//       >
//         <h3 style={{ margin: 0 }}>Memory</h3>

//         <div style={{ marginTop: 8, marginBottom: 6 }}>
//           <span style={{ marginRight: 10 }}>View:</span>
//           <span style={buttonStyle(memView === "hex")} onClick={() => setMemView("hex")}>HEX</span>
//           <span style={buttonStyle(memView === "dec")} onClick={() => setMemView("dec")}>DEC</span>
//           <span style={buttonStyle(memView === "bin")} onClick={() => setMemView("bin")}>BIN</span>

//           <input
//   value={searchHex ? `0x${searchHex}` : ""}
//   onChange={(e) => {
//     let v = e.target.value.toLowerCase();
//     if (v.startsWith("0x")) v = v.slice(2);
//     v = v.replace(/[^0-9a-f]/g, "");
//     setSearchHex(v);
//   }}
//   onKeyDown={(e) => e.key === "Enter" && jumpToAddress()}
//   placeholder="0x search addr"
//   style={{
//     marginLeft: "8px",
//     width: "120px",
//     background: "#111",
//     color: "#0f0",
//     border: "1px solid #666",
//     borderRadius: "4px",
//     padding: "2px 6px",
//     fontFamily: "monospace"
//   }}
//   title="Jump to memory address (hex)"
// />

//         </div>

//         <div style={{ display: "flex", alignItems: "center", gap: "3px", flexWrap: "wrap" }}>
//           <button onClick={() => setMemPage((p) => Math.max(p - 1, 0))} style={navBtn}>Prev</button>
//           {renderPageNumbers()}
//           <button onClick={() => setMemPage((p) => Math.min(p + 1, totalPages - 1))} style={navBtn}>Next</button>
//           <button onClick={goToSP} style={{ ...navBtn, color: "#0f0" }}>Go to SP</button>
//         </div>

//         <div style={{ display: "flex", gap: "20px", marginTop: 10, fontWeight: "bold" }}>
//           <div style={{ flex: 1, borderBottom: "1px solid #555", paddingBottom: "4px" }}>
//             <span style={{ width: "70px", display: "inline-block" }}>Address</span>
//             <span>Value</span>
//           </div>
//           <div style={{ flex: 1, borderBottom: "1px solid #555", paddingBottom: "4px" }}>
//             <span style={{ width: "70px", display: "inline-block" }}>Address</span>
//             <span>Value</span>
//           </div>
//         </div>
//       </div>

//       {/* ---------------- SCROLL BODY ---------------- */}
//       <div style={{ overflow: "auto", padding: "10px" }}>
//         <div style={{ display: "flex", gap: "20px" }}>
//           {[leftColMemory, rightColMemory].map((colMem, colIdx) => (
//             <div key={colIdx} style={{ flex: 1 }}>
//               {colMem.map((_, i) => {
//                 const globalIndex =
//                   (colIdx === 0 ? SEGMENTS.text.start : SEGMENTS.data.start) +
//                   i +
//                   memPage * HALF_PAGE;

//                 const execHighlight = highlightedAddrs.includes(globalIndex);
//                 const searchHighlight = searchedAddr === globalIndex;

//                 return (
//                   <div
//                     key={globalIndex}
//                     ref={(el) => el && rowRefs.current.set(globalIndex, el)}
//                     style={{
//                       display: "flex",
//                       borderBottom: "1px solid #333",
//                       padding: "2px 0",
//                       background: searchHighlight
//                         ? "#444"
//                         : execHighlight
//                         ? "#333"
//                         : "transparent",
//                       transition: "background 0.35s"
//                     }}
//                   >
//                     <span style={{ width: 70, color: getSegmentColor(globalIndex) }}>
//                       0x{globalIndex.toString(16).padStart(3, "0")}
//                     </span>

//                     {editingMem === globalIndex ? (
//                       <input
//                         value={tempMemValue}
//                         onChange={(e) => setTempMemValue(e.target.value)}
//                         onBlur={() => saveMemory(globalIndex)}
//                         onKeyDown={(e) => e.key === "Enter" && saveMemory(globalIndex)}
//                         autoFocus
//                         style={{
//                           width: "70px",
//                           background: "#222",
//                           color: "cyan",
//                           border: "1px solid #666",
//                           fontFamily: "monospace",
//                           padding: "2px 4px"
//                         }}
//                       />
//                     ) : (
//                       <div
//                         onDoubleClick={() => {
//                           setEditingMem(globalIndex);
//                           setTempMemValue(memory[globalIndex]);
//                         }}
//                         style={{
//                           flex: 1,
//                           cursor: "pointer",
//                           color: getSegmentColor(globalIndex),
//                           fontFamily: "monospace"
//                         }}
//                       >
//                         {formatValue(memory[globalIndex] ?? "00", memView).replace(/^0x|0b/, "")}
//                       </div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }


/* global BigInt */
import React, { useState, useRef, useEffect } from "react";

export default function Memory({
  memory,
  setMemory,
  memView,
  setMemView,
  memPage,
  setMemPage,
  highlightedAddrs,
  SEGMENTS,
  addLog,
  registers
}) {
  const PAGE_SIZE = 128;
  const HALF_PAGE = PAGE_SIZE / 2; // 64

  const totalPages = Math.ceil(
    Math.max(SEGMENTS.text.size, SEGMENTS.data.size) / HALF_PAGE
  );

  const [editingMem, setEditingMem] = useState(null);
  const [tempMemValue, setTempMemValue] = useState("");

  // 🔍 SEARCH STATE (HEX ONLY)
  const [searchHex, setSearchHex] = useState("");
  const [searchedAddr, setSearchedAddr] = useState(null);

  const rowRefs = useRef(new Map());

  // ✅ NEW: search input ref + Ctrl+F focus
  const searchInputRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      const isFind =
        (isMac && e.metaKey && e.key.toLowerCase() === "f") ||
        (!isMac && e.ctrlKey && e.key.toLowerCase() === "f");

      if (isFind) {
        e.preventDefault();
        searchInputRef.current?.focus();
        searchInputRef.current?.select();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // ---------------- HELPERS ----------------
  const parseInput = (input, view) => {
    if (!input) return NaN;
    switch (view) {
      case "hex": return parseInt(input, 16);
      case "dec": return parseInt(input, 10);
      case "bin": return parseInt(input, 2);
      default: return NaN;
    }
  };

  const saveMemory = (globalIndex) => {
    const num = parseInput(tempMemValue, memView);
    if (isNaN(num)) {
      addLog(`Invalid input for Memory[0x${globalIndex.toString(16).padStart(3, "0")}]`);
      setEditingMem(null);
      return;
    }
    if (num < 0 || num > 0xff) {
      addLog(`Error: Cannot store value in Memory[0x${globalIndex.toString(16).padStart(3, "0")}], max 8 bits allowed`);
      setEditingMem(null);
      return;
    }

    const updated = [...memory];
    updated[globalIndex] = num.toString(16).padStart(2, "0").toUpperCase();
    setMemory(updated);
    setEditingMem(null);

    addLog(`Memory[0x${globalIndex.toString(16).padStart(3, "0")}] updated to ${num} (${memView.toUpperCase()})`);
  };

  const getColumnMemory = (segmentName) => {
    const { start, size } = SEGMENTS[segmentName];
    const colMem = [];
    for (let i = 0; i < HALF_PAGE; i++) {
      const addr = start + i + memPage * HALF_PAGE;
      if (addr < start + size && addr < memory.length) colMem.push(memory[addr]);
      else colMem.push("00");
    }
    return colMem;
  };

  const getSegmentColor = (addr) => {
    for (let seg in SEGMENTS) {
      const { start, size, color } = SEGMENTS[seg];
      if (addr >= start && addr < start + size) return color;
    }
    return "#888";
  };

  const renderPageNumbers = () => {
    const pageButtons = [];
    const maxButtons = 5;

    let start = Math.max(0, memPage - Math.floor(maxButtons / 2));
    let end = Math.min(totalPages, start + maxButtons);
    if (end - start < maxButtons) start = Math.max(0, end - maxButtons);

    for (let i = start; i < end; i++) {
      pageButtons.push(
        <button
          key={i}
          onClick={() => setMemPage(i)}
          style={{
            padding: "2px 6px",
            borderRadius: "4px",
            border: "1px solid #888",
            background: i === memPage ? "#0f0" : "#222",
            color: i === memPage ? "#000" : "#fff",
            cursor: "pointer",
            fontFamily: "monospace",
            fontWeight: i === memPage ? "bold" : "normal"
          }}
        >
          {i + 1}
        </button>
      );
    }
    return pageButtons;
  };

  const formatValue = (val, view) => {
    const num = parseInt(val, 16) >>> 0;
    switch (view) {
      case "dec": return num.toString();
      case "bin": return "0b" + num.toString(2).padStart(8, "0");
      default: return "0x" + val.toUpperCase();
    }
  };

  const leftColMemory = getColumnMemory("text");
  const rightColMemory = getColumnMemory("data");

  // ✅ IMPORTANT: your UI shows left 0x000..0x7FF and right 0x800..0xFFF
  const LEFT_BASE = SEGMENTS.text.start; // 0x000
  const RIGHT_BASE = SEGMENTS.data.start; // 0x800 (2048)

  // ---------------- HEX SEARCH LOGIC (FIXED FOR YOUR 2-COLUMN LAYOUT) ----------------
  const jumpToAddress = () => {
    if (!searchHex) return;

    const addr = parseInt(searchHex, 16);
    if (isNaN(addr) || addr < 0 || addr >= memory.length) {
      addLog("Invalid memory address");
      return;
    }

    const page =
      addr < RIGHT_BASE
        ? Math.floor((addr - LEFT_BASE) / HALF_PAGE)
        : Math.floor((addr - RIGHT_BASE) / HALF_PAGE);

    setSearchedAddr(addr);
    setMemPage(Math.max(0, Math.min(page, totalPages - 1)));

    addLog(`🔍 Jumped to memory address: 0x${addr.toString(16).toUpperCase()}`);
  };

  // 🔥 Smooth scroll after page change
  useEffect(() => {
    if (searchedAddr == null) return;
    const el = rowRefs.current.get(searchedAddr);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [memPage, searchedAddr]);

  // ---------------- GO TO SP (ALSO FIXED TO MATCH YOUR 2-COLUMN LAYOUT) ----------------
  const goToSP = () => {
    if (!registers || !registers[2]) {
      addLog("SP (x2) not available");
      return;
    }

    const spAddr = parseInt(registers[2], 16);
    if (isNaN(spAddr) || spAddr < 0 || spAddr >= memory.length) {
      addLog("Invalid SP value");
      return;
    }

    const page =
      spAddr < RIGHT_BASE
        ? Math.floor((spAddr - LEFT_BASE) / HALF_PAGE)
        : Math.floor((spAddr - RIGHT_BASE) / HALF_PAGE);

    setSearchedAddr(spAddr);
    setMemPage(Math.max(0, Math.min(page, totalPages - 1)));

    addLog(`Jumped to SP (x2): 0x${spAddr.toString(16).toUpperCase()}`);
  };

  const buttonStyle = (active) => ({
    marginRight: "5px",
    padding: "2px 6px",
    border: "1px solid #888",
    borderRadius: "4px",
    background: active ? "#0f0" : "#222",
    color: active ? "#000" : "#fff",
    cursor: "pointer",
    fontWeight: active ? "bold" : "normal",
    fontFamily: "monospace"
  });

  const navBtn = {
    padding: "2px 6px",
    borderRadius: "4px",
    border: "1px solid #888",
    background: "#222",
    color: "#fff",
    cursor: "pointer",
    fontFamily: "monospace"
  };

  return (
    <div
      style={{
        flex: 0.9,
        border: "2px solid #333",
        borderRadius: "6px",
        margin: "5px",
        background: "#1b1b1b",
        display: "flex",
        flexDirection: "column",
        minHeight: 0
      }}
    >
      {/* ---------------- STICKY HEADER ---------------- */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 5,
          background: "#1b1b1b",
          padding: "10px",
          borderBottom: "1px solid #555"
        }}
      >
        <h3 style={{ margin: 0 }}>Memory</h3>

        <div style={{ marginTop: 8, marginBottom: 6 }}>
          <span style={{ marginRight: 10 }}>View:</span>
          <span style={buttonStyle(memView === "hex")} onClick={() => setMemView("hex")}>HEX</span>
          <span style={buttonStyle(memView === "dec")} onClick={() => setMemView("dec")}>DEC</span>
          <span style={buttonStyle(memView === "bin")} onClick={() => setMemView("bin")}>BIN</span>

          <input
            ref={searchInputRef}
            value={searchHex ? `0x${searchHex}` : ""}
            onChange={(e) => {
              let v = e.target.value.toLowerCase();
              if (v.startsWith("0x")) v = v.slice(2);
              v = v.replace(/[^0-9a-f]/g, "");
              setSearchHex(v);
            }}
            onKeyDown={(e) => e.key === "Enter" && jumpToAddress()}
            placeholder="0x search addr"
            style={{
              marginLeft: "8px",
              width: "120px",
              background: "#111",
              color: "#0f0",
              border: "1px solid #666",
              borderRadius: "4px",
              padding: "2px 6px",
              fontFamily: "monospace"
            }}
            title="Jump to memory address (hex)"
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "3px", flexWrap: "wrap" }}>
          <button onClick={() => setMemPage((p) => Math.max(p - 1, 0))} style={navBtn}>Prev</button>
          {renderPageNumbers()}
          <button onClick={() => setMemPage((p) => Math.min(p + 1, totalPages - 1))} style={navBtn}>Next</button>
          <button onClick={goToSP} style={{ ...navBtn, color: "#0f0" }}>Go to SP</button>
        </div>

        <div style={{ display: "flex", gap: "20px", marginTop: 10, fontWeight: "bold" }}>
          <div style={{ flex: 1, borderBottom: "1px solid #555", paddingBottom: "4px" }}>
            <span style={{ width: "70px", display: "inline-block" }}>Address</span>
            <span>Value</span>
          </div>
          <div style={{ flex: 1, borderBottom: "1px solid #555", paddingBottom: "4px" }}>
            <span style={{ width: "70px", display: "inline-block" }}>Address</span>
            <span>Value</span>
          </div>
        </div>
      </div>

      {/* ---------------- SCROLL BODY ---------------- */}
      <div style={{ overflow: "auto", padding: "10px" }}>
        <div style={{ display: "flex", gap: "20px" }}>
          {[leftColMemory, rightColMemory].map((colMem, colIdx) => (
            <div key={colIdx} style={{ flex: 1 }}>
              {colMem.map((_, i) => {
                const globalIndex =
                  (colIdx === 0 ? SEGMENTS.text.start : SEGMENTS.data.start) +
                  i +
                  memPage * HALF_PAGE;

                const execHighlight = highlightedAddrs.includes(globalIndex);
                const searchHighlight = searchedAddr === globalIndex;

                return (
                  <div
                    key={globalIndex}
                    ref={(el) => el && rowRefs.current.set(globalIndex, el)}
                    style={{
                      display: "flex",
                      borderBottom: "1px solid #333",
                      padding: "2px 0",
                      background: searchHighlight
                        ? "#444"
                        : execHighlight
                        ? "#333"
                        : "transparent",
                      transition: "background 0.35s"
                    }}
                  >
                    <span style={{ width: 70, color: getSegmentColor(globalIndex) }}>
                      0x{globalIndex.toString(16).padStart(3, "0")}
                    </span>

                    {editingMem === globalIndex ? (
                      <input
                        value={tempMemValue}
                        onChange={(e) => setTempMemValue(e.target.value)}
                        onBlur={() => saveMemory(globalIndex)}
                        onKeyDown={(e) => e.key === "Enter" && saveMemory(globalIndex)}
                        autoFocus
                        style={{
                          width: "70px",
                          background: "#222",
                          color: "cyan",
                          border: "1px solid #666",
                          fontFamily: "monospace",
                          padding: "2px 4px"
                        }}
                      />
                    ) : (
                      <div
                        onDoubleClick={() => {
                          setEditingMem(globalIndex);
                          setTempMemValue(memory[globalIndex]);
                        }}
                        style={{
                          flex: 1,
                          cursor: "pointer",
                          color: getSegmentColor(globalIndex),
                          fontFamily: "monospace"
                        }}
                      >
                        {formatValue(memory[globalIndex] ?? "00", memView).replace(/^0x|0b/, "")}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
